export default "__VITE_ASSET__4qpenEVk__"